function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-1{stroke-width:10.6021px;}.cls-2{stroke-width:3.6202px;}.cls-3{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "logo_jl_wordmark_white");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M126.4723,29.2271A24.7383,24.7383,0,1,1,101.7447,4.4888,24.7278,24.7278,0,0,1,126.4723,29.2271Z",
  transform: "translate(0 0.8123)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M42.42,49.1875a24.7382,24.7382,0,1,1-33.789,9.0459A24.7276,24.7276,0,0,1,42.42,49.1875Z",
  transform: "translate(0 0.8123)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M17.6793,131.9585a24.7379,24.7379,0,1,1-9.0606,33.7852A24.7291,24.7291,0,0,1,17.6793,131.9585Z",
  transform: "translate(0 0.8123)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M76.9918,194.771a24.7373,24.7373,0,1,1,24.7285,24.74A24.7259,24.7259,0,0,1,76.9918,194.771Z",
  transform: "translate(0 0.8123)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M161.0445,174.81a24.7371,24.7371,0,1,1,33.7891-9.0449A24.7256,24.7256,0,0,1,161.0445,174.81Z",
  transform: "translate(0 0.8123)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M185.7848,92.0391a24.7375,24.7375,0,1,1,9.0605-33.7852A24.7281,24.7281,0,0,1,185.7848,92.0391Z",
  transform: "translate(0 0.8123)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M93.7242,81.231A8.4469,8.4469,0,1,1,82.191,78.1353,8.4452,8.4452,0,0,1,93.7242,81.231Z",
  transform: "translate(0 0.8123)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M71.08,103.5494a8.4487,8.4487,0,1,1-8.4483,8.4462A8.4442,8.4442,0,0,1,71.08,103.5494Z",
  transform: "translate(0 0.8123)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M79.0894,134.32a8.445,8.445,0,1,1,3.0928,11.539A8.453,8.453,0,0,1,79.0894,134.32Z",
  transform: "translate(0 0.8123)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M109.7428,142.7652a8.4454,8.4454,0,1,1,11.5341,3.0937A8.4431,8.4431,0,0,1,109.7428,142.7652Z",
  transform: "translate(0 0.8123)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M132.38,120.4468a8.4468,8.4468,0,1,1,8.4482-8.4433A8.44,8.44,0,0,1,132.38,120.4468Z",
  transform: "translate(0 0.8123)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M124.3707,89.6822a8.4469,8.4469,0,1,1-3.0859-11.5469A8.4413,8.4413,0,0,1,124.3707,89.6822Z",
  transform: "translate(0 0.8123)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M408.4491,89.6262q0-8.4192-1.8341-13.3345a14.0286,14.0286,0,0,0-6.0282-7.43,26.6531,26.6531,0,0,0-11.0558-3.2331c-4.5536-.4643-10.2092-.7-16.937-.7h-31.5q-8.9835,0-15.116.5262a35.5463,35.5463,0,0,0-10.144,2.1414,13.64,13.64,0,0,0-6.1687,4.629,20.2592,20.2592,0,0,0-3.1611,7.9962,72.3214,72.3214,0,0,0-1.1248,12.2425q-.137,7.2623-.1405,17.3618,0,10.1063.1767,17.3685a73.9326,73.9326,0,0,0,1.1572,12.2395,20.73,20.73,0,0,0,3.1253,7.9992,13.3946,13.3946,0,0,0,6.1359,4.629,35.5281,35.5281,0,0,0,10.144,2.1444q6.1339.52,15.116.5232h31.5q7.8557,0,13.5436-.4218a49.71,49.71,0,0,0,9.6767-1.5429,17.9874,17.9874,0,0,0,6.453-3.086,13.3316,13.3316,0,0,0,3.8215-4.946,23.8117,23.8117,0,0,0,1.8632-7.1529,84.9982,84.9982,0,0,0,.4971-9.7908h13.462a80.7012,80.7012,0,0,1-.8369,12.1709,32.5612,32.5612,0,0,1-2.988,9.683,23.576,23.576,0,0,1-5.7111,7.3323,28.9665,28.9665,0,0,1-9.0554,5.0866,59.775,59.775,0,0,1-13.0466,2.9454,144.6078,144.6078,0,0,1-17.6791.9481h-31.5a120.58,120.58,0,0,1-20.8044-1.51,44.8317,44.8317,0,0,1-13.926-4.557,23.2242,23.2242,0,0,1-8.4538-7.6855,32.9286,32.9286,0,0,1-4.3477-10.87,75.7284,75.7284,0,0,1-1.5824-14.0994q-.2058-7.8652-.2092-17.4077,0-9.5323.2092-17.3946a75.6737,75.6737,0,0,1,1.5824-14.1028,32.9779,32.9779,0,0,1,4.3477-10.8727,23.25,23.25,0,0,1,8.4538-7.6855,44.8317,44.8317,0,0,1,13.926-4.557,120.9113,120.9113,0,0,1,20.8044-1.51h31.5a143.8926,143.8926,0,0,1,17.6791.9514A62.8358,62.8358,0,0,1,403.32,57.5276a29.7883,29.7883,0,0,1,9.0554,4.871,23.0348,23.0348,0,0,1,5.7111,6.95,29.431,29.431,0,0,1,2.988,9.049,69.2386,69.2386,0,0,1,.8369,11.2289Z",
  transform: "translate(0 0.8123)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M433.1433,122.3889q0-12.3132,2.6546-20.3826a26.662,26.662,0,0,1,8.5649-12.8016q5.894-4.737,15.2958-6.6394a137.2351,137.2351,0,0,1,45.7407,0q9.4047,1.9121,15.2924,6.6394a26.5816,26.5816,0,0,1,8.5585,12.8016q2.6675,8.0661,2.6677,20.3826,0,12.5185-2.6677,20.8007a27.5463,27.5463,0,0,1-8.5585,13.1547q-5.8839,4.8741-15.2924,6.8979a130.8932,130.8932,0,0,1-45.7407,0q-9.4049-2.035-15.2958-6.8979a27.63,27.63,0,0,1-8.5649-13.1547Q433.1351,134.9077,433.1433,122.3889Zm13.4654,0q0,6.6637.4937,11.6018a32.2418,32.2418,0,0,0,1.8566,8.4471,14.8172,14.8172,0,0,0,3.8249,5.77,17.8881,17.8881,0,0,0,6.4532,3.5307,42.2784,42.2784,0,0,0,9.7122,1.7979q5.7177.4906,13.5828.49,6.733,0,12.0269-.3006a44.6291,44.6291,0,0,0,9.2646-1.4254,21.4968,21.4968,0,0,0,6.77-3.158,14.8116,14.8116,0,0,0,4.5278-5.5867,31.0388,31.0388,0,0,0,2.517-8.7055,81.6018,81.6018,0,0,0,.8108-12.4614,77.4277,77.4277,0,0,0-.8108-12.1578,28.862,28.862,0,0,0-2.517-8.4471,14.5586,14.5586,0,0,0-4.5278-5.3778,20.4137,20.4137,0,0,0-6.77-2.9716,48.3987,48.3987,0,0,0-9.2646-1.2878q-5.2959-.28-12.0269-.2748-6.7376,0-12.0332.2748a48.3617,48.3617,0,0,0-9.2613,1.2878,20.2824,20.2824,0,0,0-6.767,2.9716,14.4164,14.4164,0,0,0-4.5308,5.3778,28.8635,28.8635,0,0,0-2.5237,8.4471A77.8735,77.8735,0,0,0,446.6087,122.3889Z",
  transform: "translate(0 0.8123)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M662.1305,55.9486h13.8868L619.4793,163.71H599.7209L543.14,55.9486H558.786L610.48,154.6933Z",
  transform: "translate(0 0.8123)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M709.2768,69.42H695.8114V55.9486h13.4654ZM695.8114,82.889h13.4654V163.71H695.8114Z",
  transform: "translate(0 0.8123)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M816.9952,82.889V94.0656l-67.4831,59.5656h67.4928v10.0324h-85.28V152.487l68.48-59.7061H736.22V82.889Z",
  transform: "translate(0 0.8123)"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M868.679,55.9486h17.96V163.71H873.164V67.1517L841.7353,94.1148l-6.7376-8.9833Z",
  transform: "translate(0 0.8123)"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M967.4532,154.73q10.8861,0,18.4177-.3532a61.9718,61.9718,0,0,0,12.5206-1.6443,17.9135,17.9135,0,0,0,7.7934-3.8968,15.6334,15.6334,0,0,0,4.1746-7.084,46.5073,46.5073,0,0,0,1.68-11.19q.3187-6.6984.32-16.2408a44.1222,44.1222,0,0,1-14.1713,5.0179,115.1715,115.1715,0,0,1-21.7521,1.72H953.9159q-15.1566,0-24.7662-2.1053-9.6062-2.1039-15.0474-6.3127a21.4086,21.4086,0,0,1-7.4729-10.53,48.2292,48.2292,0,0,1-2.0337-14.7334,48.23,48.23,0,0,1,2.0337-14.7337,21.37,21.37,0,0,1,7.4729-10.52Q919.54,57.9119,929.15,55.808q9.6157-2.0989,24.7662-2.1053h22.5207a120.7489,120.7489,0,0,1,20.7977,1.51,45.3,45.3,0,0,1,13.9685,4.557,22.9017,22.9017,0,0,1,8.45,7.6855,33.38,33.38,0,0,1,4.3186,10.8727,78.0944,78.0944,0,0,1,1.6115,14.1028q.25,7.8607.2454,17.3946,0,10.1063-.2845,18.2121a65.9223,65.9223,0,0,1-1.89,14.3116,28.8618,28.8618,0,0,1-5.1257,10.6933,25.1478,25.1478,0,0,1-9.9936,7.3391,63.1446,63.1446,0,0,1-16.4889,4.2071,185.76,185.76,0,0,1-24.5931,1.3665q-12.3423,0-21.4678-.9089a92.452,92.452,0,0,1-15.6031-2.7393,39.3329,39.3329,0,0,1-10.6344-4.4916,22.028,22.028,0,0,1-6.4891-6.1755,21.6925,21.6925,0,0,1-3.2264-7.7867,46.3932,46.3932,0,0,1-.8794-9.3268h11.1606a33.6587,33.6587,0,0,0,.4185,5.4,12.559,12.559,0,0,0,1.8632,4.8449,13.2934,13.2934,0,0,0,4.4492,4.0632,30.9058,30.9058,0,0,0,8.2412,3.158,83.9518,83.9518,0,0,0,13.0894,2.0333Q956.23,154.733,967.4532,154.73Zm8.9834-44.9038q11.0183,0,18.0286-.4837a32.2891,32.2891,0,0,0,10.9809-2.3212,10.1574,10.1574,0,0,0,5.4363-5.4,26.1875,26.1875,0,0,0,1.4776-9.7486,52.039,52.039,0,0,0-1.4776-13.6839,14.8594,14.8594,0,0,0-5.4363-8.2088q-3.9622-2.9419-10.9809-3.9979a125.933,125.933,0,0,0-18.0286-1.0528H953.9159c-5.2435,0-9.758.1406-13.5728.4251a58.157,58.157,0,0,0-9.683,1.399A20.3273,20.3273,0,0,0,924.2,69.42a11.9518,11.9518,0,0,0-3.8543,4.1747,16.6805,16.6805,0,0,0-1.8207,5.8876,59.5827,59.5827,0,0,0-.461,7.8947,55.9563,55.9563,0,0,0,.4935,7.8948,17.33,17.33,0,0,0,1.8568,5.8939,12.2,12.2,0,0,0,3.8249,4.1747,19.5837,19.5837,0,0,0,6.453,2.6643,59.5207,59.5207,0,0,0,9.683,1.4056q5.6835.4117,13.54.4151Z",
  transform: "translate(0 0.8123)"
});

var SvgLogoJl = function SvgLogoJl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1025.8287 225.6246",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoJl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_jl.91b9c148.svg";
export { ForwardRef as ReactComponent };